import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-action-button',
  imports: [CommonModule],
  templateUrl: './action-button.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./action-button.component.scss']
})
export class ActionButtonComponent {
  @Input() icon: string = '';
  @Input() iconColor: string = '#505050';
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Output() actionEvent = new EventEmitter();

  onActionEvent() {
    this.actionEvent.emit();
  }
}
